import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-6 col-sm-4" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "lead" }
const _hoisted_5 = { class: "col-6 col-sm-6" }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = {
  key: 0,
  class: "list-inline"
}
const _hoisted_8 = { class: "lead" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "col-6 col-sm-4" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "lead" }
const _hoisted_13 = { class: "col-6 col-sm-4" }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { class: "lead" }
const _hoisted_16 = { class: "col-6 col-sm-4" }
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = { class: "lead" }

import { PropType } from 'vue';
import { PlayerStats } from '../../../shared/app/models/index.js';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppPlayerStats',
  props: {
    playerStats: {
        type: Object as PropType<PlayerStats>,
        required: true,
    },
},
  setup(__props) {



const topBoardsizes: { boardsize: number, playedGames: number }[] = [];
let totalGames = 0;

for (const [boardsize, playedGames] of Object.entries(__props.playerStats.preferredBoardsizes)) {
    topBoardsizes.push({
        boardsize: Number(boardsize),
        playedGames,
    });

    totalGames += playedGames;
}

topBoardsizes.sort((a, b) => b.playedGames - a.playedGames);

let show = ref(0);

while (show.value < 3 && topBoardsizes.length > show.value && topBoardsizes[show.value].playedGames / totalGames >= 0.095) {
    ++show.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('total_played_games')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.playerStats.totalPlayedGames), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('preferred_board_sizes')), 1),
      (topBoardsizes.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topBoardsizes.slice(0, _unref(show)), ({ boardsize, playedGames }) => {
              return (_openBlock(), _createElementBlock("li", {
                key: boardsize,
                class: "list-inline-item"
              }, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(boardsize), 1),
                _cache[0] || (_cache[0] = _createTextVNode(" " + _toDisplayString(' ') + " ")),
                _createElementVNode("small", null, "(" + _toDisplayString(Math.round(100 * playedGames / _unref(totalGames))) + "%)", 1)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_9, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('no_yet_data')), 1)
          ]))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('ranked_games')), 1),
      _createElementVNode("p", _hoisted_12, _toDisplayString(__props.playerStats.totalRanked), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('friendly_games')), 1),
      _createElementVNode("p", _hoisted_15, _toDisplayString(__props.playerStats.totalFriendly), 1)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('bot_games')), 1),
      _createElementVNode("p", _hoisted_18, _toDisplayString(__props.playerStats.totalBotGames), 1)
    ])
  ]))
}
}

})